/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';

import {
  BufferedValue,
  bufferTemplateValue,
  createBufferedValue
} from '../util/template-state';

@Component({
  standalone: false,
  selector: 'adn-list-count-badge',
  template: '{{ countText }}',
  styles: [':host { display: inline-block; }']
})
export class ListCountBadgeComponent implements OnDestroy {
  @Input() list: any;

  private readonly countTextState: BufferedValue<string> = createBufferedValue('');
  private destroyed = false;

  constructor(private readonly cdr: ChangeDetectorRef) {
  }

  get countText(): string {
    return bufferTemplateValue(this.countTextState, this.list?.totalCountText || '', {
      isAlive: () => !this.destroyed,
      onCommit: () => this.cdr.markForCheck()
    });
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
